import React from 'react';
import { observer } from 'mobx-react';
import { WeaTop,WeaLocaleProvider,WeaTab,WeaSearchGroup,WeaInput,WeaFormItem,WeaTable,WeaRightMenu } from 'ecCom';
import {Button} from 'antd';
import TemplateManageStore from '../../stores/list/TemplateManageStore';
import { EidtTemplateDialog } from './EidtTemplate';
import { SetTemplateColumnDialog } from './SetTemplateColumn';
import {SetCustomConditionDialog} from './SetCustomCondition';
const getLabel = WeaLocaleProvider.getLabel;
import $ from 'jquery'

export interface TemplateListProps {
    templateManageStore:TemplateManageStore
}
@observer
export default class TemplateList extends React.Component<TemplateListProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            showSearchAd: false
        }
    }
    recalculateMask = () => {
        let domRootStr = $(".coms-mode-templateManage")
        if(domRootStr.length>0){
            let dom = domRootStr.find('.wea-search-container')[0];
            if(dom){
                let maskDarkHeight = window.innerHeight - dom.offsetTop - 110;
                domRootStr.find(`.mask-dark`).height(maskDarkHeight);
            }
        }
    }

    render() {
        const {templateManageStore}=this.props;
        const {iconInfo } = templateManageStore;
        return (<div style={{height:'100%'}}>
            <WeaRightMenu ecId={`${this && this.props && this.props.ecId || ''}_WeaRightMenu@127seh`}
                datas={[{
                    key: 'add',
                    icon: <i className='icon-coms-New-Flow' />,
                    content: getLabel(82, '新建', 'label'),
                },{
                    key: 'search',
                    icon: <i className='icon-coms-search' />,
                    content: getLabel(197, '搜索', 'label'),
                }]}
                onClick={templateManageStore.rightClick}
                collectParams={{
                    "favname": getLabel(17857, "模板管理"),
                    "link": '/' + window.location.toString().split('/').slice(3).join('/'),
                    "favouritetype": 5,
                    "importantlevel": 1
                }}
            >
                <WeaTop ecId={`${this && this.props && this.props.ecId || ''}_WeaTop@s5612b`}
                    title={getLabel(17857, "模板管理")}
                    icon={<i className={iconInfo.icon} style={{color:iconInfo.iconColor}} />}
                    iconBgcolor={iconInfo.iconBg}
                    buttons={[
                        <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@rf5hcx@add`} type='primary' onClick={()=>{templateManageStore.add()}}>{getLabel(82, "新建")}</Button>
                    ]}
                />
                <WeaTab ecId={`${this && this.props && this.props.ecId || ''}_WeaTab@edc7p0`}
                    searchType={['base','advanced']}
                    onSearch={v => {
                        templateManageStore.searchByName(v);
                    }}
                    searchsBaseValue={templateManageStore.templateName1}
                    showSearchAd={this.state.showSearchAd}
                    setShowSearchAd={bool=>{
                        this.setState({
                            showSearchAd: bool
                        })
                    }}
                    advanceHeight={'auto'}
                    searchsAd={<WeaSearchGroup ecId={`${this && this.props && this.props.ecId || ''}_WeaSearchGroup@vokc90`} title={getLabel(20331, "查询条件")} items={[
                        {com:<WeaFormItem ecId={`${this && this.props && this.props.ecId || ''}_WeaFormItem@j1z4pl`}
                            label={getLabel(18151, "模板名称")}
                            ratio1to2
                        >
                            <WeaInput ecId={`${this && this.props && this.props.ecId || ''}_WeaInput@f3923h`} onChange={v=>templateManageStore.templateName=v} value={templateManageStore.templateName} />
                        </WeaFormItem>,
                        colSpan: 1}
                    ]} center showGroup={true} onVisibleChange={this.recalculateMask}/>}
                    buttonsAd={[
                        <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@nukk1v@searchByName`} type="primary" onClick={()=>{templateManageStore.searchByName(templateManageStore.templateName);this.setState({showSearchAd: false});}}>{getLabel(387355, "搜索")}</Button>,
                        <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@krq5mx@templateName`} type="ghost" onClick={()=>{templateManageStore.templateName=''}}>{getLabel(2022, "重置")}</Button>,
                        <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@6jk34y@cancel`} type="ghost" onClick={()=>{
                            this.setState({showSearchAd: false})
                        }}>{getLabel(201, "取消")}</Button>
                    ]}/>
                    <WeaTable ecId={`${this && this.props && this.props.ecId || ''}_WeaTable@0t3kvo`} loading={templateManageStore.loading} columns={templateManageStore.columns}
                    dataSource={templateManageStore.templateListDatas}
                    pagination={templateManageStore.pagination}
                    onChange={pagination=>{templateManageStore.handleTableChange(pagination);}}/>
            </WeaRightMenu>
            <EidtTemplateDialog ecId={`${this && this.props && this.props.ecId || ''}_EidtTemplateDialog@8c9wbz`} templateManageStore={templateManageStore}/>
            <SetTemplateColumnDialog ecId={`${this && this.props && this.props.ecId || ''}_SetTemplateColumnDialog@mhin7y`} templateManageStore={templateManageStore}/>
            <SetCustomConditionDialog ecId={`${this && this.props && this.props.ecId || ''}_SetCustomConditionDialog@s43loy`} templateManageStore={templateManageStore}/>
        </div>
        )
    }
}




// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/pages/templateManage/TemplateList.tsx